"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var core_1 = require("@material-ui/core");
exports["default"] = (function (_a) {
    var children = _a.children, to = _a.to, className = _a.className, external = _a.external;
    if (external) {
        return (react_1["default"].createElement(core_1.Link, { href: to, target: "_blank", rel: "noopener noreferrrer", className: className }, children));
    }
    return (react_1["default"].createElement(core_1.Link, { component: react_router_dom_1.Link, to: to, className: className }, children));
});
